import type { HeaderControlFavoritesProps } from '@maestro/commerce-blocks/components/header-controls/header-controls.types'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { HeaderControl } from '@maestro/commerce-blocks/components/header-controls'
import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { getFavoriteListsUrl } from '@maestro/commerce-blocks/utils/favorite-urls.utils'
import { theme } from '@maestro/local/theme'

export default function HeaderControlFavorites(
  props: HeaderControlFavoritesProps
) {
  const { handleClickWishlist, wishlistCount } = props
  const {
    favorites: { favoritesImplementation, favoritesAdvancedVariant },
  } = theme()
  const t = useTranslations('commerce-blocks')
  const url = getFavoriteListsUrl()
  const { session } = useMaestroSession()
  const isLoggedIn = useMemo(() => {
    return !!session
  }, [session])

  return (
    <>
      {favoritesImplementation === 'simple' ? (
        <HeaderControl
          icon="heart-empty"
          ariaLabel={t('wishlist.contains-items', { count: wishlistCount })}
          onClick={handleClickWishlist}
          count={wishlistCount}
        />
      ) : isLoggedIn ? (
        <HeaderControl
          icon="shopping-list"
          ariaLabel={t(`favorites.your-lists.${favoritesAdvancedVariant}`)}
          title={t('account.shopping-lists')}
          url={url}
        />
      ) : null}
    </>
  )
}
